module.exports = __webpack_public_path__ + "img/spinner.4ba61248.gif";